import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../axios-Instance";
import { getLoginToken } from "../storage";
import { queryKeys } from "../react-query/constants";
import { successAlert, toastOptions } from "../utils";
import { toast } from "react-toastify";

const SERVER_ERROR = "There was an error contacting the server.";

async function createOnboardingResponse(formData: any) {
  const data = await axiosInstance({
    url: "/onboardingResponse",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useCreateOnboardingResponse() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => createOnboardingResponse(formData),
    onSuccess: () => {
      queryClient.invalidateQueries([
        queryKeys.category,
        "onboardingResponse status",
      ]);
      //   successAlert("Information Added successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function getOnboardingResponse() {
  const data = await axiosInstance({
    url: "/onboardingResponse/me",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

// export function useGetOnboardingResponse() {
//   const fallback: any = [];
//   const { data = fallback } = useQuery({
//     queryKey: [queryKeys.onboardingResponse],
//     queryFn: getOnboardingResponse,
//   });
//   return data;
// }

export function useGetOnboardingResponse() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.onboardingResponse],
    queryFn: getOnboardingResponse,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
  return data;
}

async function deleteOnboardingResponse(questionId: string) {
  const data = await axiosInstance({
    url: `/onboardingResponse/${questionId}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useDeleteOnboardingResponse(questionId: string) {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: () => deleteOnboardingResponse(questionId),
    onSuccess: () => {
      queryClient.invalidateQueries(["onboardingResponse status"]);
      queryClient.invalidateQueries([queryKeys.onboardingResponse]);
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function updateOnboardingResponse(questionId: string, formData: any) {
  const data = await axiosInstance({
    url: `/onboardingResponse/${questionId}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useUpdateOnboardingResponse(questionId: string) {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => updateOnboardingResponse(questionId, formData),
    onSuccess: () => {
      queryClient.invalidateQueries(["onboardingResponse status"]);
      queryClient.invalidateQueries([queryKeys.onboardingResponse]);
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

// Get all response for Admin
async function allOnboardingResponse() {
  const data = await axiosInstance({
    url: "/onboardingResponse",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useGetAllOnboardingResponse() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.onboardingResponse],
    queryFn: allOnboardingResponse,
  });
  return data;
}

async function getStatus() {
  const data = await axiosInstance({
    url: "/onboardingResponse/status",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useGetOnboardStatus() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: ["onboardingResponse status"],
    queryFn: getStatus,
  });
  return data;
}
